import React from 'react';
import { classes } from '../../../lib';
import Styles from './Persona.module.less';
import { PersonaMedia, PersonaMediaProps } from './PersonaMedia';

export type PersonaProps = {
    link: React.ReactNode;
    title: string;
    children: React.ReactNode;
    reversed?: boolean;
} & PersonaMediaProps;

export const Persona = ({
    link,
    title,
    children,
    reversed,
    ...mediaProps
}: PersonaProps): JSX.Element => {
    return (
        <div
            className={classes(
                'd-horizontal d-stretch-middle mt-vertical mt-stretch-top g40 lp-section',
                Styles.container,
                reversed && Styles.reversed
            )}>
            <div className={classes('vertical left-top g56 flex', Styles.text)}>
                <div className="vertical stretch-top g24">
                    <h3>{title}</h3>
                    <span className="secondary-text semilarge-alude">
                        {children}
                    </span>
                </div>
                {link}
            </div>
            <PersonaMedia {...mediaProps} className={Styles.homeImageWrapper} />
        </div>
    );
};
